import { getApiCountryCode } from '../services/http';

const seenImpressions = new Set();

export const makeImpressionKey = ({ campaign, page, placement, domain = '', device = '', country } = {}) => {
  const cc = country != null && String(country) !== '' ? String(country).toLowerCase().slice(0, 2) : getApiCountryCode() || '';
  return [campaign || '', page || '', placement || '', domain || '', device || '', cc].join('|');
};

export const shouldTrackImpression = (key) => {
  if (!key) return false;
  if (seenImpressions.has(key)) return false;
  seenImpressions.add(key);
  return true;
};

export const makeServerEventKey = (payload, eventType) => {
  const { campaign, page, placement, domain = '', device = '', country = '' } = payload || {};
  const cc =
    country != null && String(country) !== ''
      ? String(country).toLowerCase().slice(0, 2)
      : getApiCountryCode() || '';
  return [String(campaign || ''), String(page || ''), String(placement || ''), String(domain || ''), String(device || ''), cc, eventType].join('|');
};
